import * as actions from './actions';
import HeaderApi from '../../../../services/HeaderApi';

export const getOutageBannerDetails = () => dispatch => {
  dispatch(actions.fetchOutageBannerDetailsBegin());

  return HeaderApi.fetchAppSettings(['OutageBanner'])
    .then(response => {
      dispatch(actions.fetchOutageBannerDetailsSuccess(response));
    })
    .catch(error => {
      // eslint-disable-next-line
      console.error(error);
      dispatch(actions.fetchOutageBannerDetailsFailure(error));
    });
};
